<template>
  <div class="match">
    <section class="peer">
      <h3 class="peer--title" v-if="!this.rematch">
        Match Selected {{ this.$root.config.mentee_label_singular }}
      </h3>
      <h3 class="peer--title" v-else>
        Re-match {{ this.$root.config.mentee_label_singular }}
      </h3>
      <section v-if="!menteesToMatch" class="peer">
        <section class="peer--content peer--content-done">
          <h3 class="peer--name">All Done</h3>
          <p>All the waiting Peers have been matched with Mentors. Nice work!</p>
        </section>
        <div class="peer--footer">
          <router-link v-bind:to="{ name: 'AdminHomePeers' }" class="btn btn-prev">Back to all Peers</router-link>
        </div>
      </section>
      <section class="peer--content" v-if="menteesToMatch && currentMentee != undefined">
        <h4 class="peer--name">
          {{ currentMentee.first_name }} {{ currentMentee.last_name }}
        </h4>
        <table class="person_details" aria-label="User details">
          <tbody>
            <tr>
              <th scope="row" class="person_details--header">Condition</th>
              <td class="person_details--data">{{ generateConditionsList() }}</td>
            </tr>
            <tr>
              <th scope="row" class="person_details--header">Email</th>
              <td class="person_details--data">{{ currentMentee.email }}</td>
            </tr>
            <tr>
              <th scope="row" class="person_details--header">Phone</th>
              <td class="person_details--data">{{ currentMentee.phone }}</td>
            </tr>
            <tr>
              <th scope="row" class="person_details--header">City</th>
              <td class="person_details--data">{{ currentMentee.city }}</td>
            </tr>
            <tr>
              <th scope="row" class="person_details--header">Age</th>
              <td class="person_details--data">{{ this.rematch? getYears(currentMentee.birth_date) : currentMentee.age }}</td>
            </tr>
            <tr>
              <th scope="row" class="person_details--header">Gender</th>
              <td class="person_details--data">{{ currentMentee.gender }}</td>
            </tr>
            <tr>
              <th scope="row" class="person_details--header">Ethnicity</th>
              <td class="person_details--data">
                {{ currentMentee.ethnicity }}
              </td>
            </tr>
            <tr>
              <th scope="row" class="person_details--header">Language</th>
              <td class="person_details--data">{{ this.rematch ? getLanguageName(currentMentee.language_code) : currentMentee.language }}</td>
            </tr>            
              <template v-if="(currentMentee?.extra_fields instanceof Object)">
                <tr v-for="(value, key) in currentMentee.extra_fields" v-bind:key="key">
                  <template v-if="key != null">
                    <th scope="row" class="person_details--header">{{ key }}</th>
                    <td v-if="Array.isArray(value)" class="person_details--data">
                      {{  value.join(', ') }}
                    </td>
                    <td v-else class="person_details--data">
                      {{ value }}
                    </td>
                  </template>
                </tr>
              </template>
            
          </tbody>
        </table>
      </section>
      <div class="peer--footer"  v-if="menteesToMatch && currentMentee != undefined">
        <a
          v-if="!this.rematch"
          v-on:click="getPreviousMentee"
          href="#"
          class="btn btn-prev"
          v-bind:class="{ 'btn-disabled': currentMentee.index === 0 }"
          >Previous {{ this.$root.config.mentee_label_singular }}</a
        >
        <a
          v-if="!this.rematch"
          v-on:click="getNextMentee"
          href="#"
          class="btn btn-next"
          v-bind:class="{
            'btn-disabled': currentMentee.index === mentees.length - 1,
          }"
          >Next {{ this.$root.config.mentee_label_singular }}</a
        >
      </div>
    </section>
    <div v-if="!menteesToMatch" class="cards cards-empty">
      <div class="cards--content">
      </div>
    </div>
    <section v-else class="cards">
      <div class="cards--header">
        <h3 class="cards--title">
          Potential {{ this.$root.config.mentor_label_plural }}
        </h3>
        <div class="cards--filter" v-if="showKidneyFilter">
          <span class="cards--filter-section-label">Filter:</span>
          <input class="cards--filter-input" type="radio" id="radio-kidney-all" name="kidney" value="all" v-model="kidneyFilter" />
          <label class="cards--filter-label" for="radio-kidney-all">All Kidney</label>
          <input class="cards--filter-input" type="radio" id="radio-kidney-recipient" name="kidney" value="recipient" v-model="kidneyFilter" />
          <label class="cards--filter-label" for="radio-kidney-recipient">Recipient</label>
          <input class="cards--filter-input" type="radio" id="radio-kidney-donor" name="kidney" value="donor" v-model="kidneyFilter" />
          <label class="cards--filter-label" for="radio-kidney-donor">Donor</label>
        </div>
      </div>
      <div class="cards--content">
        <section
          v-for="match in filteredPotentialMatches"
          v-bind:key="match.id"
          class="card"
        >
          <h4 class="card--title">
            {{ match.first_name }} {{ match.last_name }}
          </h4>
          <table class="person_details" aria-label="User details">
            <tbody>
              <tr>
                <th scope="row" class="person_details--header">Email</th>
                <td class="person_details--data">
                  {{ match.email }}
                </td>
              </tr>
              <tr>
                <th scope="row" class="person_details--header">Phone</th>
                <td class="person_details--data">{{ match.phone }}</td>
              </tr>
              <tr>
                <th scope="row" class="person_details--header">Gender</th>
                <td class="person_details--data">
                  <span
                    class="card--match"
                    v-bind:class="getMatchFlagClass(match.gender.match)"
                    aria-label="match"
                    >&#9745;</span
                  >
                  {{ match.gender.value }}
                </td>
              </tr>
              <tr>
                <th scope="row" class="person_details--header">Age</th>
                <td class="person_details--data">
                  <span
                    class="card--match"
                    v-bind:class="getMatchFlagClass(match.age.match)"
                    aria-label="match"
                    >&#9745;</span
                  >
                  {{ match.age.value }}
                </td>
              </tr>
              <tr>
                <th scope="row" class="person_details--header">Ethnicity</th>
                <td class="person_details--data">
                  <span
                    class="card--match"
                    v-bind:class="getMatchFlagClass(match.ethnicity.match)"
                    aria-label="match"
                    >&#9745;</span
                  >
                  {{ match.ethnicity.value }}
                </td>
              </tr>
              <tr>
                <th scope="row" class="person_details--header">Language</th>
                <td class="person_details--data">
                  <span
                    class="card--match"
                    v-bind:class="getMatchFlagClass(match.language.match)"
                    aria-label="match"
                    >&#9745;</span
                  >
                  {{ match.language.value }}
                </td>
              </tr>
              <template v-if="Array.isArray(match.extra_fields)">
                <tr v-for="field in match.extra_fields" v-bind:key="field.label">
                  <th scope="row" class="person_details--header">{{ field.label }}</th>
                  <td class="person_details--data">
                  <span
                    class="card--match"
                    v-bind:class="getMatchFlagClass(field.match)"
                    aria-label="match"
                    >&#9745;</span
                  >
                    <template v-if="/^\[\'/.test(field.value)">
                      &nbsp;{{ field.value.replaceAll(/[\[\]\']/g, '') }}
                    </template>
                    <template v-else>
                      &nbsp;{{ field.value }}
                    </template>
                </td>
                </tr>
              </template>
            </tbody>
          </table>
          <div class="card--slots slots">
            <strong class="slots--number">{{ match.slots_taken }}</strong> &nbsp;<template
              v-if="match.slots_taken !== 1"
              >{{ this.$root.config.mentee_label_plural }}</template
            >
            <template v-else>{{
              this.$root.config.mentee_label_singular
            }}</template>
          </div>
          <button
            v-if="currentMentee.match === null"
            v-on:click="this.match(currentMentee.id, match.id)"
            href="#"
            class="btn"

            >Select</button
          >
          <template v-else>
            <button 
              v-if="currentMentee.match === match.id" 
              class="btn btn-disabled"
             disabled="disabled"
              >Matched</button
            >
          </template>
        </section>
        <div v-if="potentialMatches.length === 0" class="card card-empty">
          <div>
            No {{ this.$root.config.mentor_label_plural }} Currently Available
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import BodyClass from "../mixins/BodyClass";
import PageTitle from "../mixins/PageTitle";
export default {
  name: "AdminMatching",

  mixins: [BodyClass, PageTitle],

  data() {
    return {
      bodyClass: "admin",
      mentees: [], // All unmatched peers
      currentMentee: {}, // The peer currently displayed
      potentialMatches: [],
      rematch: false,
      languages: [],
      conditions: [],
      loading: true,
      extraFields: [],
      kidneyFilter: "all",
    };
  },

  watch: {
    currentMentee() {
      if (this.currentMentee !== undefined) {
        // disease condition array has different name in return value from the rematch call
        // and uses language_code instead of language
        if (this.currentMentee.disease_conditions == undefined && this.currentMentee.disease_condition != undefined) {
          this.currentMentee.disease_conditions = this.currentMentee.disease_condition;
          this.currentMentee.language = this.$i18n.messages[this.currentMentee.language_code].languageName;
        }
        this.getMatchingMentors(this.currentMentee.id);
        console.log("WATCH");
        console.log(this.currentMentee);
        console.log(this.conditions);
        const conditionDefinition = this.conditions.find(
          item => item.title === this.currentMentee.disease_conditions[0].title
        );
        //this.currentMentee.conditionFields = conditionDefinition.extra_fields_form;
      }
    },
  },

  computed: {
    menteesToMatch() {
      // Wait until initial data load complete before calculating remaining unmatched mentees
      if (this.loading) {
        return true;
      }
      const unmatched = this.mentees.filter(
        (mentee) => mentee.match === null
      );
      return unmatched.length > 0;
    },
    showKidneyFilter() {
      let x= this.generateConditionsList()
      if(typeof x=='string'){
        return x.includes("Kidney Transplant");
      }
      return false
    },
    filteredPotentialMatches() {
      console.log("FILTERED POTENTIAL MATCHES :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::");
      console.log('Current kidney filter:', this.kidneyFilter);
      console.log('Potential matches:', this.potentialMatches);

      // Return early if no matches exist
      if (!this.potentialMatches || !Array.isArray(this.potentialMatches)) {
        return [];
      }

      if (this.potentialMatches.length == 0) {
        console.log("ZERO LENGTH")
        return [];
      }

      // Return all matches if no filter is applied
      if (!this.showKidneyFilter || this.kidneyFilter === 'all') {
        return this.potentialMatches;
      }
      
      return this.potentialMatches.filter(match => {
        try {
          // Find the "Type of patient" field in the extra_fields array
          const patientTypeField = match.extra_fields?.find(
            field => field.label === "Type of patient"
          );
          
          const mentorPatientType = patientTypeField?.value?.toLowerCase();
          
          // Log for debugging
          console.log('Checking mentor:', {
            id: match.id,
            patientType: mentorPatientType,
            filter: this.kidneyFilter
          });

          switch(this.kidneyFilter) {
            case 'donor':
              return mentorPatientType === 'donor';
            case 'recipient':
              return mentorPatientType === 'recipient';
            default:
              return false;
          }
        } catch (error) {
          console.error('Error filtering match:', error, match);
          return false;
        }
      });
    },
  },

  created() {
    
    // We need to pre-load disease conditions so it will be available when we load a mentee with extra matching fields
    this.$root.callAuthenticatedEndpointNEW("getConditions", (items) => {
      this.conditions = items;

      const qs = new URLSearchParams(location.search);
      // Rematching uses different endpoints versus first-time matching
      if (qs.has('rematch') && qs.has('id')) {
        console.log("REMATCH!");
        this.rematch = true;

        let $view = this;
        let userToMatch = qs.get("id");
        // Rematch is for a single user only
        console.log("PRE GET USER");
        this.$root.callAuthenticatedEndpointNEW("getUser", (user) => {
          user.index = 0;
          user.match = null;
          $view.mentees.push(user);
          $view.currentMentee = user;
          this.currentMentee = user;
          this.loading = false;

          // We also need extra fields if we're using GET user, to retrieve labels and values
          const globalConds = this.$root.getLookupValues('condition');
          const conditionDefinition = globalConds.find(item => item.title === this.currentMentee.disease_conditions[0].title);
          if (conditionDefinition !== undefined) {
            this.extraFields = conditionDefinition.extra_fields_form;
          }
          
        },
        userToMatch,
        "mentee");

      } else {
        let $view = this;
        let userToMatch = null;
        // If the query string contains an ID param, that user will be active on load
        if (qs.has("id")) {
          userToMatch = qs.get("id");
        }
        this.$root.callAuthenticatedEndpointNEW("getUsersToMatch", (users) => {
          console.log("!!UNM!!");
          console.log(users);
          users.forEach(function (value, index) {
            
            value.index = index;
            
            value.match = null;
            if (value.id === userToMatch) {
              $view.currentMentee = value;
            }
          });
          this.mentees = users;
          // If the query string is empty, the first peer in the list will be active on load
          if (userToMatch === null) {
            this.currentMentee = this.mentees[0];
          }
          this.loading = false;
        });
      }

    });   
    
    this.languages = this.$root.getLookupValues("language");

  },

  methods: {
    // getExtraFieldLabel(fieldId) {
    //   if (this.currentMentee.conditionFields === null) {
    //     return null;
    //   }
    //   for (let group of this.currentMentee.conditionFields.form_groups) {
    //       console.log(group);
    //     for (let field of group.form_fields) {
    //       console.log(field);
    //       if (field.id === fieldId) {
    //         return field.label;
    //       }
    //     }
    //   }
    // },

    // getExtraFieldValue(fieldId, answer) {
    //   if (this.currentMentee.conditionFields === null) {
    //     return null;
    //   }
    //   for (let group of this.currentMentee.conditionFields.form_groups) {
    //       console.log(group);
    //     for (let field of group.form_fields) {
    //       console.log(field);
    //       if (field.id === fieldId) {
    //         // Pass through answer for text
    //         if (field.type === 'text') {
    //           return answer;
    //         }
    //         for (let option of field.field_options) {
    //           if (option.id === answer) {
    //             return option.label;
    //           }
    //         }
    //       }
    //     }
    //   }
    // },

    displayExtraFieldAnswer(field, answer) {
      if (Array.isArray(answer)) {
          return answer.join(", ");
        }
        return answer;
    },

    getLanguageName(langCode) {
      if (langCode == '') return '';
      const theLang = this.languages.find(lang => lang.code === langCode);
      return theLang !== undefined ? theLang.title : '';
    },

    getMatchFlagClass(isMatch) {
      if (isMatch) {
        return "card--match-yes";
      }
      return "card--match-no";
    },

    getNextMentee() {
      let i = this.currentMentee.index + 1;
      if (i < this.mentees.length) {
        this.currentMentee = this.mentees[i];
      }
    },
    getPreviousMentee() {
      let i = this.currentMentee.index - 1;
      if (i >= 0) {
        this.currentMentee = this.mentees[i];
      }
    },

    getMatchingMentors(userId) {
      
      let endpoint = "getMatchingUsers";
      if (this.rematch) {
        endpoint = "getMatchingUsersForRematch";
      }
      this.$root.callAuthenticatedEndpointNEW(
        endpoint,
        (output) => {
          if (output.length == 0) {
            console.log("NO POTENTIAL MATCHES");
          } else {
            this.potentialMatches = output[0].potential_mentors;
            this.extraFields = output[0].extra_fields;
            console.log("POTENTIAL MATCHES", this.potentialMatches);
          }
        },
        userId
      );
    },

    getYears(date2) {
      const date1 = new Date();
      let years = new Date(date1).getFullYear() - new Date(date2).getFullYear();
      let month = new Date(date1).getMonth() - new Date(date2).getMonth();
      let dateDiff = new Date(date1).getDay() - new Date(date2).getDay();
      if (dateDiff < 0) {
          month -= 1;
      }
      if (month < 0) {
          years -= 1;
      }
      return years;
    },

    match(menteeId, mentorId) {
      
      let endpoint = "matchUsers";
      if (this.rematch) {
        endpoint = "rematchUsers";
      }
      
      this.$root.callAuthenticatedEndpointNEW(
        endpoint,
        (output) => {
          console.log(output);
          this.$root.decrementUnmatchedMenteeCount();
        },
        menteeId,
        mentorId
      );

      //update the current display
      this.currentMentee.match = mentorId;

      
      console.log("Count of unmatched: ")

      // Update the mentees object, in case the user navigates forward/back then returns to this slide
      this.mentees[this.currentMentee.index].match = mentorId;
      // Increment the matched peer counter for the mentor just matched
      // TODO needs rework
      const i = this.potentialMatches.findIndex((mentor) => {
        if (mentor.id === mentorId) {
          return true;
        }
        return false;
      });
      console.log(i);
      this.potentialMatches[i].slots_taken++;

    },

    generateConditionsList() {
      try {
        if (!this.currentMentee) return '';
        if (!this.currentMentee.disease_conditions) return '';
        if (!Array.isArray(this.currentMentee.disease_conditions)) return '';
        
        if (this.rematch) {
          return this.currentMentee.disease_conditions[0].title;
        }
        return this.currentMentee.disease_conditions.join(", ");
      } catch (error) {
        console.error('Error generating conditions list:', error);
        return '';
      }
    },

  },
};
</script>


